declare global {
    interface Window {
        newrelic?: any;
    }
}

export const NEW_RELIC_EVENT_KEYS = {
    APP_MULTI_REFRESH: 'appMultiRefresh',
    CLIENT_LOCAL_CACHE: 'clientLocalCache',
    CLIENT_LOCAL_CACHE_REHYDRATION: 'clientLocalCacheRehydration',
    WORKSPACE_INITIALISATION_TIME: 'workspaceInitialisationTime',
};

export const isNewRelicAvailable = (): boolean => !!window.newrelic && typeof window.newrelic === 'object';

export const sendNewRelicCustomAttribute = (key: string, value: string | boolean | number): void => {
    if (!isNewRelicAvailable()) return;

    window.newrelic.setCustomAttribute(key, value);
};

export const sendNewRelicPageAction = (actionName: string, attributes: Record<string, string | boolean> = {}): void => {
    if (!isNewRelicAvailable()) return;

    window.newrelic.addPageAction(actionName, attributes);
};

export const setNewRelicUserId = (userId: string | null): void => {
    if (!isNewRelicAvailable()) return;

    window.newrelic.setUserId(userId || 'guest');
};
